"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListingEvent$ = exports.ListingEvent$outboundSchema = exports.ListingEvent$inboundSchema = void 0;
exports.listingEventToJSON = listingEventToJSON;
exports.listingEventFromJSON = listingEventFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
/** @internal */
exports.ListingEvent$inboundSchema = z.object({
    date: z.string().transform(v => new rfcdate_js_1.RFCDate(v)),
    event_type: z.string(),
    related_price: z.nullable(z.number().int()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "event_type": "eventType",
        "related_price": "relatedPrice",
    });
});
/** @internal */
exports.ListingEvent$outboundSchema = z.object({
    date: z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString()),
    eventType: z.string(),
    relatedPrice: z.nullable(z.number().int()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        eventType: "event_type",
        relatedPrice: "related_price",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var ListingEvent$;
(function (ListingEvent$) {
    /** @deprecated use `ListingEvent$inboundSchema` instead. */
    ListingEvent$.inboundSchema = exports.ListingEvent$inboundSchema;
    /** @deprecated use `ListingEvent$outboundSchema` instead. */
    ListingEvent$.outboundSchema = exports.ListingEvent$outboundSchema;
})(ListingEvent$ || (exports.ListingEvent$ = ListingEvent$ = {}));
function listingEventToJSON(listingEvent) {
    return JSON.stringify(exports.ListingEvent$outboundSchema.parse(listingEvent));
}
function listingEventFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.ListingEvent$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'ListingEvent' from JSON`);
}
//# sourceMappingURL=listingevent.js.map